import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchMarriageDetailNotificationsShared from 'shell/components/shared/research-notifications/research-marriage/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface ResearchMarriageDetailNotificationsCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
  items?: BreadcrumbItem[];
}

const ResearchMarriageDetailNotificationsCivilStatusShared = ({
  scope,
  isOther,
  items,
}: ResearchMarriageDetailNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <ResearchMarriageDetailNotificationsShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isOther={isOther}
      />
    </Fragment>
  );
};

ResearchMarriageDetailNotificationsCivilStatusShared.displayName =
  'Research Marriage Detail Notifications CivilStatusShared component';

export default ResearchMarriageDetailNotificationsCivilStatusShared;
